<template>
  <ValidationProvider
      v-slot="{ errors, classes }"
      :class="$attrs.class"
      :mode="customValidate"
      :rules="rules"
      class="form-group w-full" tag="div"
  >
    <label v-if="label" class="block text-base font-normal mb-1">
      {{ label }}
      <b v-if="isRequired" class="ml-1 text-red-600 font-bold">*</b>
    </label>
    <div class="relative input-group">
      <VueSelect
          ref="select"
          v-model="dropdownValue"
          :class="[{'tags-input': !search}]"
          :disabled="disabled"
          :options="paginated"
          :placeholder="placeholder"
          class="form-control"
          multiple
          taggable
          @close="onClose"
          @open="onOpen"
          @search="onSearch"
          v-on="$listeners"
          @option:selected="onSelected"
      >
        <template #option="{label}">
          <div :class="[{'font-bold' : isSelectedOptionItem(label)}]">{{ label }}</div>
        </template>
        <template #no-options="{searching}">
          <div v-if="search" class="px-3 py-2 text-center">
            <span v-if="!loading"> {{ $t("No items in select") }}</span>
          </div>
          <div v-else/>
        </template>
        <template #list-footer>
          <li v-show="loading" ref="load" class="list-footer">
            <i class="fa-solid fa-spin fa-circle-notch"></i> {{ $t('Data loading') }}
          </li>
        </template>
      </VueSelect>
    </div>
    <span class="text-xs text-gray-400">{{ $t("Type and press enter to create a tag") }}</span>

    <span class="text-xs text-red-600">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {$wait, convertAccentedLettersToUnsigned} from "@/helpers/helpers";
import Select from "@/components/select/Select.vue";

export default {
  name: "TagsInput",
  mixins: [Select],
  components: {
    VueSelect
  },
  props: {
    value: [Number, String, Array, Object],
    label: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    rules: String,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    filtered() {
      const q = convertAccentedLettersToUnsigned(this.keyword.toLowerCase());
      return this.items.filter(item => convertAccentedLettersToUnsigned(item.toLowerCase()).includes(q))
    },
    dropdownValue: {
      get() {
        return this.value === 0 || this.value === "" ? null : this.value;
      },
      set(newDropdownValue) {
        this.$emit("input", newDropdownValue);
        this.$emit("change", newDropdownValue);
      }
    },
  },
  mounted() {
  },
  watch: {},
  methods: {
    async onSelected() {
      await $wait(100)
      const input = document.querySelector(".tags-input input");
      input.focus();
    },
    isSelectedOptionItem(item) {
      return this.value?.toString() === item?.toString();
    }
  }
}
</script>
<style lang="scss">
.tags-input {
  .vs__actions {
    display: none;
  }

  .vs__dropdown-menu {
    display: none;
  }
}
</style>

